// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Badge-module__root--yR1DX {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 4px;
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
}

.Badge-module__variant-default--tqU3f {
  /* 기본 variant에는 별도의 시각 스타일을 지정하지 않는다. */
}

.Badge-module__variant-ghost--DzJBm {
  background: #fff;
  box-shadow: inset 0 0 0 1px #c9c9c9;
  color: #666;
}

.Badge-module__variant-ghost--DzJBm.Badge-module__is-reverse--R15DJ {
  background: transparent;
  box-shadow: inset 0 0 0 1px rgb(255 255 255 / 15%);
  color: #fff;
}

.Badge-module__variant-soft--iwikF {
  background: #fff4df;
  color: #a05a27;
}

.Badge-module__variant-subtle--RCT7J {
  background: #E7E5E2;
  color: #1a1a1a;
}

.Badge-module__size-x-small--AJr54 {
  height: 16px;
  padding-inline: 8px;
  font-size: 0.625rem; /* 10px */
  font-weight: 300;
}

.Badge-module__size-small--njsLB {
  height: 28px;
  padding-inline: 10px;
  font-size: 0.75rem; /* 12px */
}

.Badge-module__size-medium--KKX9L {
  height: 32px;
  padding-inline: 11px;
  font-size: 0.8125rem; /* 13px */
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Badge/Badge.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kDAAkD;EAClD,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB,EAAE,SAAS;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB,EAAE,SAAS;AAC/B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oBAAoB,EAAE,SAAS;AACjC","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  border-radius: 4px;\n  font-weight: 700;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.variant-default {\n  /* 기본 variant에는 별도의 시각 스타일을 지정하지 않는다. */\n}\n\n.variant-ghost {\n  background: #fff;\n  box-shadow: inset 0 0 0 1px #c9c9c9;\n  color: #666;\n}\n\n.variant-ghost.is-reverse {\n  background: transparent;\n  box-shadow: inset 0 0 0 1px rgb(255 255 255 / 15%);\n  color: #fff;\n}\n\n.variant-soft {\n  background: #fff4df;\n  color: #a05a27;\n}\n\n.variant-subtle {\n  background: #E7E5E2;\n  color: #1a1a1a;\n}\n\n.size-x-small {\n  height: 16px;\n  padding-inline: 8px;\n  font-size: 0.625rem; /* 10px */\n  font-weight: 300;\n}\n\n.size-small {\n  height: 28px;\n  padding-inline: 10px;\n  font-size: 0.75rem; /* 12px */\n}\n\n.size-medium {\n  height: 32px;\n  padding-inline: 11px;\n  font-size: 0.8125rem; /* 13px */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Badge-module__root--yR1DX`,
	"variant-default": `Badge-module__variant-default--tqU3f`,
	"variant-ghost": `Badge-module__variant-ghost--DzJBm`,
	"is-reverse": `Badge-module__is-reverse--R15DJ`,
	"variant-soft": `Badge-module__variant-soft--iwikF`,
	"variant-subtle": `Badge-module__variant-subtle--RCT7J`,
	"size-x-small": `Badge-module__size-x-small--AJr54`,
	"size-small": `Badge-module__size-small--njsLB`,
	"size-medium": `Badge-module__size-medium--KKX9L`
};
export default ___CSS_LOADER_EXPORT___;
